var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40104 3.45768C1.66882 3.18989 2.10299 3.18989 2.37078 3.45768L6.0002 7.08709L9.62961 3.45768C9.8974 3.18989 10.3316 3.18989 10.5994 3.45768C10.8671 3.72547 10.8671 4.15964 10.5994 4.42742L6.48507 8.54171C6.21728 8.8095 5.78311 8.8095 5.51532 8.54171L1.40104 4.42742C1.13325 4.15964 1.13325 3.72547 1.40104 3.45768Z",
    fill: "#334155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownicon);
export default __webpack_public_path__ + "static/media/downicon.7bf7b553921b048c9fbc90d067c445d5.svg";
export { ForwardRef as ReactComponent };